import fadeInAnimation from "./home-fade-in-animations.js";
import { escapeHtml, getWorkCardLayout } from "./archive-card-layout.js";

function loadMoreWorks() {
  const loadMoreButton = document.querySelector("#see-more-work");
  const worksContentContainer = document.querySelector(
    ".works-content-container",
  );
  if (!loadMoreButton || !worksContentContainer) return;
  const config = window.BBDO_CONFIG || {};
  const assetsBase = document.documentElement.dataset.assetsBase || "assets";
  const totalPages = Number(
    document.documentElement.dataset.workTotalPages || 1,
  );
  let currentPage = 1;

  if (currentPage >= totalPages) loadMoreButton.hidden = true;

  loadMoreButton.addEventListener("click", (event) => {
    event.preventDefault();
    currentPage++;

    const endpoint = config.workEndpoint
      ? `${config.workEndpoint}${config.workEndpoint.includes("?") ? "&" : "?"}page=${currentPage}`
      : `${assetsBase}/data/work-page-${currentPage}.json`;

    fetch(endpoint, {
      headers: config.restNonce ? { "X-WP-Nonce": config.restNonce } : {},
    })
      .then((response) => {
        if (currentPage >= totalPages) loadMoreButton.hidden = true;

        if (!response.ok)
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        return response.json();
      })
      .then((responseData) => {
        const data = Array.isArray(responseData)
          ? responseData
          : responseData.items || [];
        if (responseData.totalPages) {
          loadMoreButton.hidden = currentPage >= responseData.totalPages;
        }
        const existingGrids = worksContentContainer.querySelectorAll(
          ".works-grid-container[data-animation]",
        );
        existingGrids.forEach((grid) => grid.removeAttribute("data-animation"));

        const grid = `
					<div class="works-grid-container" data-animation="fade-in">
					${data
            .map((item, i) => {
              const layout = getWorkCardLayout(i, item.layout);
              const isMainCard = layout === "portrait";
              const src = isMainCard
                ? item.acf?.image_vertical || item.acf?.image
                : item.acf?.image || item.acf?.image_vertical;
              const title = item.title?.rendered || "Fără titlu";
              return `
							<a href="${escapeHtml(item.link || "#")}" class="card-work ${isMainCard ? "main-card" : ""}" data-card-layout="${layout}">
								<div class="card-work-container">
									<div class="image-container">
										${src ? `<img src="${escapeHtml(src)}" alt="Imagine ${escapeHtml(title)}" loading="lazy">` : ""}
									</div>
									<div class="card-work-text-content">
										<h2>${escapeHtml(title)}</h2>
										<div class="subtitle-line">
											<div class="line"></div>
											<h3>${escapeHtml(item.acf?.additional_text || "")}</h3>
										</div>
									</div>
								</div>
							</a>`;
            })
            .join("")}
					</div>`;

        worksContentContainer.insertAdjacentHTML("beforeend", grid);
        fadeInAnimation();
      })
      .catch((error) =>
        console.error("Eroare la încărcarea proiectelor locale:", error),
      );
  });
}

export default loadMoreWorks;
